export class Site {

    public phoneNumber : string

    public address : string[]
}
